// Geometry for emoji-only ("super jumbo") message rows. Single source shared with the
// renderer's constants: EmojiEntity.jsx renders superJumbo glyphs at `size-25` (100px)
// when useEntityReplacer passes containsOnlyEmojiEntities, inside a zero-padding bubble
// (`richdown-bubble--channel-message-contains-only-emoji-entities` = p-0); adjacent
// entities get `ml-2` (8px) gaps and wrap as inline content.

/** Rendered box of one super-jumbo emoji glyph (`size-25`). */
export const SUPER_JUMBO_EMOJI_PX = 100;
/** Horizontal gap between adjacent emoji entities (`ml-2`). */
export const SUPER_JUMBO_EMOJI_GAP_PX = 8;

/**
 * Estimates an emoji-only row's height: glyphs are a constant 100px regardless of count,
 * so height is line count × glyph height, where wrapping follows inline flow at the
 * given content width. Residual line-box leading is corrected pre-paint by measurement.
 */
export function estimateEmojiOnlyHeight(count: number, contentWidth: number): number {
  const glyphs = Math.max(1, Math.floor(count));
  const perLine = Math.max(
    1,
    Math.floor(
      (contentWidth + SUPER_JUMBO_EMOJI_GAP_PX) / (SUPER_JUMBO_EMOJI_PX + SUPER_JUMBO_EMOJI_GAP_PX)
    )
  );
  const lines = Math.ceil(glyphs / perLine);
  return lines * SUPER_JUMBO_EMOJI_PX;
}
